import { createSlice } from "@reduxjs/toolkit";
import {
  addArticle,
  deleteArticle,
  getArticles,
  toggleArticleStatus,
  updateArticle,
} from "../../api/article/article";

// giá trị khởi tạo của state
const initialState = {
    articles: [],
  isLoading: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API
};

const articleSlice = createSlice({
  name: "article", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getArticles.pending, (state) => {
        // api đnag pending chờ xử lý
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getArticles.fulfilled, (state, action) => {
        // api trả về thành công thì trả ra
        state.isLoading = false;
        state.articles = action.payload.data || [];
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getArticles.rejected, (state, action) => {
        // api trả về thất bại thì trả ra
        state.isLoading = false;
        state.error = action.payload;
      });

    // Add Article
    builder.addCase(addArticle.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(addArticle.fulfilled, (state, action) => {
      state.isLoading = false;
      // We don't need to update the articles array here as we'll refetch after add
    });
    builder.addCase(addArticle.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Không thể thêm bài viết";
    });

    // Update Article
    builder.addCase(updateArticle.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(updateArticle.fulfilled, (state, action) => {
      state.isLoading = false;
      // We don't need to update the articles array here as we'll refetch after update
    });
    builder.addCase(updateArticle.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Không thể cập nhật bài viết";
    });

    // Delete Article
    builder.addCase(deleteArticle.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(deleteArticle.fulfilled, (state, action) => {
      state.isLoading = false;
      state.articles = state.articles.filter(
        (article) => article.id !== action.payload.id
      );
      // Total count will be updated on next fetch
    });
    builder.addCase(deleteArticle.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Không thể xóa bài viết";
    });

    // Toggle Article Status
    builder.addCase(toggleArticleStatus.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(toggleArticleStatus.fulfilled, (state, action) => {
      state.isLoading = false;
      // We'll refetch the updated list after toggling status
    });
    builder.addCase(toggleArticleStatus.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Không thể cập nhật trạng thái bài viết";
    });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } =
  articleSlice.actions;
export default articleSlice.reducer;
